import moment from 'moment';

import i18n from '../i18n';
import { defaultEmptyCellValue } from './stringHandler';

const LANGUAGE_TO_INTL_LOCALE = {
  de_DE: 'de-DE',
  en_US: 'en-GB',
  pt_BR: 'pt-BR'
};

const LANGUAGE_TO_MOMENT_LOCALE = {
  de_DE: 'de',
  en_US: 'en-gb',
  pt_BR: 'pt-br'
};

const getCurrentLanguage = () => i18n.resolvedLanguage || i18n.language || 'en_US';

const getIntlLocale = (language = getCurrentLanguage()) => LANGUAGE_TO_INTL_LOCALE[language] || 'en-GB';

const getMomentLocale = (language = getCurrentLanguage()) => LANGUAGE_TO_MOMENT_LOCALE[language] || 'en-gb';

const getValidDate = value => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
};

const formatLocalizedDate = (value, fallback = defaultEmptyCellValue) => {
  const date = getValidDate(value);

  if (!date) {
    return fallback;
  }

  return date.toLocaleDateString(getIntlLocale());
};

const formatLocalizedTime = (value, fallback = defaultEmptyCellValue) => {
  const date = getValidDate(value);

  if (!date) {
    return fallback;
  }

  return date.toLocaleTimeString(getIntlLocale());
};

const getLocalizedDateTimeParts = value => {
  const date = getValidDate(value);

  if (!date) {
    return null;
  }

  return {
    date: date.toLocaleDateString(getIntlLocale()),
    time: date.toLocaleTimeString(getIntlLocale())
  };
};

const formatLocalizedDateTime = (value, formatter, fallback = defaultEmptyCellValue) => {
  const dateTimeParts = getLocalizedDateTimeParts(value);

  if (!dateTimeParts) {
    return fallback;
  }

  return formatter(dateTimeParts);
};

const formatLocalizedMoment = (value, format = 'LLLL', fallback = defaultEmptyCellValue) => {
  const localizedMoment = moment(value ?? null).locale(getMomentLocale());

  if (!localizedMoment.isValid()) {
    return fallback;
  }

  return localizedMoment.format(format);
};

export {
  formatLocalizedDate,
  formatLocalizedTime,
  formatLocalizedDateTime,
  formatLocalizedMoment,
  getIntlLocale,
  getLocalizedDateTimeParts
};
